import { Theme, createStyles, makeStyles, styled } from '@material-ui/core/styles';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_DRAWER,
  DARK_SIDE_NAV,
  DISABLED_ICON,
  LIGHT_SIDE_NAV,
  PLAIN_ICON,
  PLAIN_TEXT,
  PRIMARY_ICON,
  PRIMARY_SIDE_NAV_ITEM_BORDER,
  PRIMARY_TEXT,
  LIGHT_SIDE_NAV_ITEM_HOVER,
  DARK_SIDE_NAV_ITEM_HOVER,
} = COLORS;

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawerContainer: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      backgroundColor: theme.palette.type === 'dark' ? DARK_SIDE_NAV : LIGHT_SIDE_NAV,
      borderRight: 'none',
    },
    menuList: {
      flex: 1,
      margin: '0',
      '& .MuiListItem-root': {
        opacity: 1,
        whiteSpace: 'break-spaces',
        textAlign: 'center',

        '& svg path': {
          fill: theme.palette.type === 'dark' ? DISABLED_ICON : PLAIN_ICON,
        },
      },
      '& .MuiListItem-root:hover svg path': {
        fill: theme.palette.type === 'dark' ? `${PLAIN_ICON} !important` : `${PRIMARY_ICON} !important`,
      },
      '& .MuiListItem-root svg': {
        width: '21px',
      },
      ' & .MuiListItem-root:hover span': {
        color: PLAIN_TEXT,
        opacity: 1,
      },
    },
    drawerHeader: {
      paddingTop: 10,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    drawer: {
      width: 115,
      flexShrink: 0,
      whiteSpace: 'nowrap',
      '& .MuiList-root': {
        overflow: 'auto',
      },
    },
    drawerOpen: {
      backgroundColor: DARK_DRAWER,
      width: 115,
      overflowY: 'visible',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerClose: {
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      overflowY: 'visible',
      width: 115,
      backgroundColor: DARK_DRAWER,
      '& .MuiListItemText-root': {
        display: 'none',
      },
    },

    collapseContainerSmall: {},
    hidden: {
      display: 'none !important',
    },

    collapseContainer: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'flex-end',
      marginBottom: -20,
    },
    collapseButton: {
      position: 'absolute',
      top: -24,
      right: -24,
    },
    switchContent: {
      display: 'flex',
      color: PLAIN_TEXT,
      padding: '10px',
      cursor: 'pointer',
      textDecoration: 'none',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      '& .MuiFormControlLabel-root': {
        marginRight: '0px',
        marginLeft: '0px',
      },
    },
  }),
);

export const useMainListeItemStyle = makeStyles((theme: Theme) => {
  return createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '15px 16px !important',
      '& *': {
        margin: '0 !important',
      },
      '& svg': {
        marginBottom: '5px !important',
      },
      '& > div:first-child': {
        display: 'flex',
        justifyContent: 'center',
      },
      '& > div:last-child *': {
        fontSize: '12px',
      },
      '& > div > span': {
        opacity: theme.palette.type === 'dark' ? 0.6 : 1,
      },
      '& > div > svg path': {},
      '&$selected': {
        backgroundColor: 'transparent',
        borderRight: `solid 1px ${PRIMARY_SIDE_NAV_ITEM_BORDER}`,
        '& > div > span': {
          color: (theme.palette.type === 'dark' ? PLAIN_TEXT : PLAIN_TEXT) + '!important',
          visibility: 'visible',
          opacity: 1,
        },
        '& > div > svg path': {
          fill: (theme.palette.type === 'dark' ? PRIMARY_ICON : PRIMARY_ICON) + '!important',
        },
      },
      '&$selected:hover': {
        backgroundColor:
          theme.palette.type === 'dark'
            ? `${DARK_SIDE_NAV_ITEM_HOVER} !important`
            : `${COLORS.LIGHT_SIDE_NAV_ITEM_HOVER} !important`,
        '& > div > span': {
          color: theme.palette.type === 'dark' ? `${PLAIN_TEXT} !important` : `${PRIMARY_TEXT} !important`,
          visibility: 'visible',
        },
        '& > div > svg path': {
          fill: (theme.palette.type === 'dark' ? PRIMARY_ICON : PRIMARY_ICON) + '!important',
        },
      },
      '&:hover': {
        backgroundColor:
          theme.palette.type === 'dark'
            ? `${DARK_SIDE_NAV_ITEM_HOVER} !important`
            : `${LIGHT_SIDE_NAV_ITEM_HOVER} !important`,
        '& > div > span': {
          visibility: 'visible',
          color: (theme.palette.type === 'dark' ? PLAIN_TEXT : PRIMARY_TEXT) + '!important',
        },
      },
      '& span': {
        fontSize: '12px',
        color: PLAIN_TEXT,
      },
      '& .MuiListItemIcon-root': {
        minWidth: '46px',
      },
    },
    selected: {},
  });
});
